/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface LiteracyLookup { 
    readonly id: string;
    /**
     * UUID of the literacy for historical reasons.
     */
    readonly uuid: string;
    /**
     * Zadejte název gramotnosti.
     */
    title: string;
}